import { consoleLogger } from '../config/di/container';

export const isLinkedInPixelLoaded = (): boolean => {
  return !!(window as any)._linkedin_data_partner_ids;
};

/**
 * Loads linkedIn's pixel script(s) into the current DOM.
 * Returns a promise which resolves to {@code true} if the script needs to be initialized after.
 */
export function loadLinkedInPixel(linkedInPixelId?: string): Promise<boolean> {
  if (!linkedInPixelId) {
    // don't try to load it if no linkedInPixelId got provided
    consoleLogger.error('Failed to load pixel', {
      pixel: 'linkedIn',
      reason: 'No id provided!'
    });
    return Promise.resolve(false);
  }

  if (isLinkedInPixelLoaded()) {
    consoleLogger.debug('⚙️ Linkedin is already attached to DOM');
    return Promise.resolve(false);
  }

  return new Promise((resolve, reject) => {
    const anyWindow = window as any;
    anyWindow._linkedin_data_partner_ids = anyWindow._linkedin_data_partner_ids || [];
    anyWindow._linkedin_data_partner_ids.push(linkedInPixelId);

    (function (l) {
      if (!l) {
        anyWindow.lintrk = function (a: any, b: any) {
          anyWindow.lintrk.q.push([a, b]);
        };
        anyWindow.lintrk.q = [];
      }

      var b = document.createElement('script');
      b.id = 'LinkedinPixel';
      b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      b.type = 'text/plain';
      b.async = true;
      b.setAttribute('data-cookieconsent', 'marketing');
      b.onerror = function () {
        reject('failed to load linkedIn pixel script');
      };
      document.head.appendChild(b);

      var ns = document.createElement('noscript');
      var i = document.createElement('img');
      i.height = 1;
      i.width = 1;
      i.src = 'data:,';
      i.setAttribute('style', 'display:none;');
      i.setAttribute(
        'data-cookieblock-src',
        `https://px.ads.linkedin.com/collect/?pid=${linkedInPixelId}&fmt=gif`
      );
      i.setAttribute('data-cookieconsent', 'marketing');
      i.alt = 'linkedin tracking pixel';
      i.onerror = function () {
        reject('failed to load linkedIn tracking pixel');
      };

      ns.appendChild(i);
      document.head.appendChild(ns);
      resolve(false);
      consoleLogger.debug('⚙️ Pixel added to DOM', {
        pixel: 'linkedIn',
        id: linkedInPixelId
      });
    })((window as any).lintrk);
  });
}

/**
 * Init linkedIn's pixel script.
 * Returns a promise which resolves to {@code true} if linkedIn pixel is ready to use.
 */
export function initLinkedInPixel(initNeeded: boolean, linkedInPixelId?: string): Promise<boolean> {
  if (!linkedInPixelId) {
    consoleLogger.debug('⚠️ LINKEDIN_PIXEL_PARTNER_ID is not set. initLinkedInPixel was triggered');
  }

  // Nothing to do right now.
  return Promise.resolve(true);
}
